export const studyLevelText = {
  Бакалавриат: 'бакалавриата',
  Магистратура: 'магистратуры',
  Специалитет: 'специалитета'
}
